// extracted by mini-css-extract-plugin
export default {"container":"Ro-z","bubbleNav":"So-z","graphic":"To-z","contact":"Uo-z"};